import { FORM_ERROR } from 'final-form';
import PropTypes from 'prop-types';
import React from 'react';
import { Form } from 'react-final-form';
import { connect } from 'react-redux';
import ResetPasswordForm from '../../components/auth/ResetPasswordForm.jsx';
import { mapFinalFormErrors } from '../../lib/utils.js';
import { setPassword } from '../../modules/auth.js';

const mapDispatch = { setPassword };

const mapErrors = mapFinalFormErrors('Failed to update password.');

const onSubmit = (setPassword, resetPasswordToken) => (values) =>
  setPassword({ resetPasswordToken, ...values })
    .then(() => undefined)
    .catch((error) => {
      const formErrors = mapErrors(error);
      if (formErrors.resetPasswordToken) {
        // Use token error as main error if it exists
        formErrors[FORM_ERROR] = formErrors.resetPasswordToken;
      }
      return formErrors;
    });

const validate = (values) => {
  const errors = {};

  if (!values.password) {
    errors.password = 'Password is required';
  }

  if (!values.passwordConfirmation) {
    errors.passwordConfirmation = 'Confirm Password is required';
  } else if (values.password !== values.passwordConfirmation) {
    errors.passwordConfirmation = 'Passwords must match';
  }

  return errors;
};

function ResetPasswordFormContainer({ resetPasswordToken, setPassword }) {
  return (
    <Form
      component={ResetPasswordForm}
      onSubmit={onSubmit(setPassword, resetPasswordToken)}
      validate={validate}
    />
  );
}

ResetPasswordFormContainer.propTypes = {
  resetPasswordToken: PropTypes.string.isRequired,
};

export default connect(null, mapDispatch)(ResetPasswordFormContainer);
